import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  /**
   *
   */
  constructor(protected sanitizer: DomSanitizer) { }
  transform(value: string): SafeHtml {
    const sanitizedHTML = this.sanitizer.sanitize(1, value); // 1 corresponds to SecurityContext.HTML
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedHTML);
  }
}
